// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2v2va","option":"styles_option__1iVP_","active":"styles_active__2oJyc"};